import React from 'react'
import EditIcon from '@mui/icons-material/Edit';
import { Tooltip } from '@mui/material'

//positionIco = left, rigth
const ValueWithEdit = ({ value, setOpen, textTooltip, positionIco = 'left' }) => {
  return (
    <div className={`valueWithEdit valueWithEdit__${positionIco}`}>
		{
			positionIco === 'left' ?
				<Tooltip title={textTooltip}>
					<EditIcon 
						onClick={e => setOpen(true)}
					/>
				</Tooltip>
			: ''
		}
        <p>
            {value}
        </p>
		{
			positionIco === 'right' ?
				<Tooltip title={textTooltip}>
					<EditIcon 
						onClick={e => setOpen(true)}
					/>
				</Tooltip>
			: ''
		}
    </div>
  )
}

export default ValueWithEdit